<template>
    <input  type="text"
            :ref="'input' + uid"
            v-model="displayedNumber"
            @blur="numberChangedTrigger"
            @focus="focusTrigger"
            class="form-control"
            :disabled="disabled ? disabled : false"
            :data-number="tempNumber" />
</template>

<script>
    export default {
        props: {
            value: 0,
            disabled: {
                type: Boolean,
                default: false
            }
        },
        name: 'priceInput',
        data() {
            return {
                fetched:            false,
                displayedNumber:    '',
                tempNumber:         '',
                uid:                null
            }
        },
        mounted(){
            this.uid = this._uid;
            this.displayedNumber = this.value ? this.value.toString() : '0';
            this.tempNumber = this.value ? this.value.toString() : '0';
            this.fetched = true;
            this.numberChanged();
        },
        methods: {
            focusTrigger(){
                this.$emit('focus', this.tempNumber);
            },
            numberChangedTrigger(){
                this.numberChanged();
                this.$emit('change', this.tempNumber);
                this.$emit('blur', this.tempNumber);
            },
            numberChanged(){
                this.tempNumber = this.toRound(this.toFloat(this.displayedNumber));
                this.displayedNumber = Vue.toNumber(this.tempNumber);
                if(this.fetched){
                    this.$emit('input', this.tempNumber);
                }
            },
            toFloat(number){
                return parseFloat(number.replace(/[,]/g, '.').replace(/[\s]/g, ''));
            },
            toRound(n){return Math.round(n*100)/100;},
            toNumber(n) {
                return this.numberFormat(n, 2, ',', ' ');
            },
            numberFormat(number, decimals, dec_point, thousands_sep) {
                number = (number + '').replace(',', '').replace(' ', '');
                var n = !isFinite(+number) ? 0 : +number,
                    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                    sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                    dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
                    s = '',
                    toFixedFix = function (n, prec) {
                        var k = Math.pow(10, prec);
                        return '' + Math.round(n * k) / k;
                    };
                // Fix for IE parseFloat(0.55).toFixed(0) = 0;
                s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
                if (s[0].length > 3) {
                    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
                }
                if ((s[1] || '').length < prec) {
                    s[1] = s[1] || '';
                    s[1] += new Array(prec - s[1].length + 1).join('0');
                }
                return s.join(dec);
            }
        },
        watch: {
            value: function () {
                this.displayedNumber = this.value.toString();
                this.tempNumber = this.value.toString();
                this.numberChanged();
            },
        }
    }
</script>
